/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

const COMPONENT_QUERY_PARAMS = Object.freeze({
  PAGE: 'page',
  SORT: 'sort',
  SIZE: 'size',
  FILTER: 'filter',
});

const COMPONENT_QUERY_DEFAULT_PARAMS = Object.freeze({
  PAGE: 0,
  SORT: null,
  SIZE: 10,
  FILTER: null,
});

export { COMPONENT_QUERY_PARAMS, COMPONENT_QUERY_DEFAULT_PARAMS };
